module.exports = __webpack_public_path__ + "static/media/Aleron_ENERGIA.f8c46ee8.png";